import { Component } from '@angular/core';

@Component({
  selector: 'app-body',
  templateUrl: './body.component.html',
  styleUrls: ['./body.component.scss'],
  standalone: false,
})
export class BodyComponent {
  boxes = [
    {
      image: '../../assets/images/mobile-dashboard.png',
      title: 'Mobile App',
      description: 'Stay connected and handle tasks on the go.',
      link: '#',
      linkText: 'Get Mobile App →',
    },
    {
      image: '../../assets/images/web-dashboard.png',
      title: 'Web Dashboard',
      description: 'Manage your school seamlessly from any computer, anytime.',
      link: '#',
      linkText: 'Get Dashboard App →',
    },
    {
      image: '../../assets/images/tablet-dashboard.png',
      title: 'Tablet Module',
      description: 'Effortless school management, right at your fingertips.',
      link: '#',
      linkText: 'Get Tablet App →',
    },
  ];
}
